/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/resource': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<circle pid="0" cx="10" cy="10" r="10"/>'
  }
})
